module.exports = __webpack_public_path__ + "static/media/sweeney_bell_paula_toward_mar.8bfd0204.jpg";